import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { BillingAccountsNavEn, BillingAccountsNavSp } from '../../../global/constants/navigation-lists';
import { TcsmStates } from '../../../root/tcsm-model';
import { BillingAccount } from '../features/billing-accounts/billing-accounts-models';
import { GroupsState } from '../features/groups/groups-model';
import { SearchProps } from '../models/arc-epi-props';

interface BillingAccountInfoHeaderProps {	
	basePath: string,
}

export function BillingAccountInfoHeader(props: BillingAccountInfoHeaderProps){
	
	const location = useLocation();
	const groupsState = useSelector<TcsmStates, GroupsState>(state => state.groupsState);
	const selectedBillingAccount = useSelector<TcsmStates, BillingAccount>(state => state.billingAccountsState?.currentBillingAccount);	
	const searchSettings = useSelector<TcsmStates, SearchProps>(state => state.epiProps?.searchSettingsState?.epiContent);
	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const pathName = location.pathname.toLocaleLowerCase();	
	const navOptions = language === 'en' ? BillingAccountsNavEn(props.basePath) : BillingAccountsNavSp(props.basePath);

	if (!groupsState?.currentGroup?.group_id ||
		!selectedBillingAccount?.account_number ||
		!location.pathname?.includes(props.basePath) ||
		(!navOptions.some(a => pathName === a.value?.toLocaleLowerCase() || pathName === a.fallbackMatch?.toLocaleLowerCase()))) return null;
    
	return (
		<div>
			<h4>{selectedBillingAccount?.account_name}</h4>
			<p>{searchSettings?.accountNumberLabel}: {selectedBillingAccount?.account_number}</p>			
			<p>{searchSettings?.groupNameLabel}: {groupsState?.currentGroup?.name}</p>
			<p>{searchSettings?.billingAccountGroupIdLabel}: {groupsState?.currentGroup?.group_id}</p>
			<p>{searchSettings?.clientIdLabel}: {groupsState?.currentGroup?.client_number}</p>
		</div>
	);
}